module.exports = function() {
  return new Worker(__webpack_public_path__ + "5e7801acc31c230e564d.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/pdfjs-dist/~/worker-loader/dist/cjs.js!./~/pdfjs-dist/build/pdf.worker.js
// module id = 566
// module chunks = 1